import type { FetcherAxiosInstance } from '../fetcher';

export const createFavoritesApi = (Fetcher: FetcherAxiosInstance) => ({
  loadFavorites() {
    return Fetcher.get('profiles/favorites');
  },

  addToFavorites(productId: string) {
    return Fetcher.post('profiles/favorites', { productId });
  },

  removeFromFavorites(productId: string) {
    return Fetcher.delete(`profiles/favorites/${productId}`);
  },
});
